import type { IconKey } from './icons';
import { renderIcon } from './icons';

export type SidebarItem = {
  id: string;
  label: string;
  icon: IconKey;
  active?: boolean;
};

export type SidebarProps = {
  brand: string;
  items: SidebarItem[];
  /**
   * When true, applies the `is-open` modifier on the root `<aside>`. The
   * mobile overlay drawer pattern (see `AxiMobileMenuToggle` +
   * `docs/specs/2026-07-10-responsive-layout/`) toggles this from
   * outside. On desktop the value is irrelevant — `.axi-sidebar` is
   * always visible there.
   */
  isOpen?: boolean;
};

function Sidebar({ brand, items, isOpen }: SidebarProps) {
  return (
    <aside
      id="axi-sidebar"
      className={'axi-sidebar' + (isOpen ? ' is-open' : '')}
      aria-label="主导航"
    >
      <div className="axi-sidebar__brand">
        <span className="axi-sidebar__brand-mark" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="12,3 21,12 12,21 3,12" />
          </svg>
        </span>
        <span className="axi-sidebar__brand-text">{brand}</span>
      </div>
      <ul className="axi-sidebar__nav-list">
        {items.map((item) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              className={
                item.active
                  ? 'axi-sidebar__nav-item is-active'
                  : 'axi-sidebar__nav-item'
              }
              aria-current={item.active ? 'page' : undefined}
            >
              <span className="axi-sidebar__nav-icon">{renderIcon(item.icon, 20)}</span>
              <span className="axi-sidebar__nav-label">{item.label}</span>
            </a>
          </li>
        ))}
      </ul>
    </aside>
  );
}

export default Sidebar;